<template>
  <div class="playvideo">
    <video
      crossorigin="anonymous"
      name="playvideocon"
      class="playvideocon"
      ref="video"
      @ended="playend"
      @contextmenu.prevent
    ></video>
    <img v-show="videoEnd" src="/static/img/video/classover.jpg" alt="" />
    <div
      class="bottom"
      @mouseenter="bottomShow = true"
      @mousemove="bottomShowFn"
      @mouseleave="bottomShow = false"
      v-if="[121, 123, 124].includes(lesson_type)"
    >
      <transition name="fade">
        <div class="bottom_sub" v-show="bottomShow" @click.stop>
          <div class="bottom_cont">
            <span class="video-currentTime">{{ currentTime | time }}</span>
            <div class="input_box">
              <input
                class="range"
                type="range"
                @change="range"
                @mousedown="rangeMousedown"
                @mouseup="rangeMouseup"
                v-model="currentTime"
                :max="durationTime"
                ref="range"
                min="0"
                step="1"
                :style="{
                  backgroundSize:
                    (currentTime / durationTime || 0) * 100 + '% 100%',
                }"
              />
            </div>
            <span class="video-duration">{{ durationTime | time }}</span>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import Hls from 'hls.js';
import { mapState, mapMutations, mapActions } from 'vuex';
import common from 'common';
export default {
  data() {
    return {
      videoUrl: '',
      sendLogData: '',
      sendLogArr: [],
      currentTime: 0, //视频当前播放时长
      durationTime: '', //视频总时长
      videoLoadTimeoutInterval: null,
      videoEnd: false,
      bottomShow: true,
      bottomInterval: null,
      isDrag: false,
      nowTimeRecord: 0, //当前时间戳记录（s）
      hlsObj: null,
      video: null,
    };
  },
  mounted() {
    this.getSendLogFn();
    this.eventHub();
    this.$nextTick(this.creatPlayer);
  },
  computed: {
    ...mapState([
      'liveVideoUrlData',
      'lesson_id',
      'exp_live_timeout',
      'live_video_mp4_appoint_time',
      'video_stream_load_timeout',
      'lesson_type',
      'class_type',
      'playbackUrl',
      'class_type',
      'teacher_id',
    ]),
  },
  methods: {
    ...mapMutations(['upDateLessonState']),
    ...mapActions(['getSendLog', 'getSendLogForRecord']),
    bottomShowFn() {
      clearTimeout(this.bottomInterval);
      if (this.bottomShow && !this.isDrag) {
        this.bottomInterval = setTimeout(() => {
          this.bottomShow = false;
        }, 5000);
      }
    },
    range() {
      this.$refs.video.currentTime = this.currentTime;
      this.$refs.video.play();
      this.bottomShow = false;
    },
    rangeMousedown() {
      clearTimeout(this.bottomInterval);
      this.isDrag = true;
    },
    rangeMouseup() {
      this.isDrag = false;
    },
    getSendLogFn() {
      // 录播课请求新的题列表接口
      if (this.class_type === 10) {
        this.getSendLogForRecord({
          lessonId: this.lesson_id,
        }).then(({ res, ok }) => {
          if (!ok) return;
          let newRes = {};
          for (let k in res) {
            newRes[k] = {
              value: res[k].quickQuestionId,
              type: 'send_quick_question',
              q_type: res[k].qtype,
              correct_answer: res[k].correctAnswer,
              uniqueId: res[k].uniqueId,
            };
          }
          this.sendLogData = newRes;
          this.sendLogArr = Object.keys(this.sendLogData);
        });
      } else {
        this.getSendLog({
          lesson_id: this.lesson_id,
        }).then(({ res, ok }) => {
          if (!ok) return;
          this.sendLogData = res;
          this;
          this.sendLogArr = Object.keys(this.sendLogData);
          // this.sendLogData = {
          // "1": {//发题时间点（单位秒）
          // "value": "3",//题ID
          // "type": "send_quick_question", //消息类型为此时是发题
          // "q_type": "1" //1:标准问答，2：快速问答，3：交互问答
          // },
          // "1686": {//发金币时间点（单位秒）
          // "value": "1",//发多少个金币
          // "type": "add_coin" //消息类型为此时是发群体加金币
          // }
          //       }
        });
      }
    },
    eventHub() {
      this.offEventHub();
      this.$root.eventHub.$on('restartVideo', () => {
        this.reconnection();
      });
      this.$root.eventHub.$on('firstPlayVideo', () => {
        this.playVideo();
      });
      this.$root.eventHub.$on('videoMuted', (muted) => {
        this.$refs.video.muted = muted;
      });
      this.$root.eventHub.$on('destroyVideo', () => {
        this.destroyVideo();
      });
    },
    playVideo() {
      console.log(170, '播放视频');
      this.$emit('tip', false);
      let temServerTime = common.getTemServerTime();
      let ctime =
        temServerTime - (this.currentTime + this.live_video_mp4_appoint_time);
      if (
        ctime * 1000 > this.exp_live_timeout &&
        this.live_video_mp4_appoint_time != 0
      ) {
        let currentTime = temServerTime - this.live_video_mp4_appoint_time;
        if (currentTime >= this.durationTime && this.durationTime != '') {
          this.destroyVideo();
          this.removeEventListener();
          this.videoEnd = true;
          return;
        }
        this.$refs.video.currentTime = currentTime;
        this.$refs.video.play();
        this.$root.eventHub.$emit('createLog', {
          id: 'LMTrackEventTYKSeekTime',
          data: {
            client_time: temServerTime, // 客户端当前时间(秒),
            appoint_time: this.live_video_mp4_appoint_time, // 体验课开课时间(秒)
            seek_time: currentTime, //seek 到的时间点(秒)
          },
        });
      } else {
        this.$refs.video.play();
      }
    },
    offEventHub() {
      this.$root.eventHub.$off('restartVideo');
      this.$root.eventHub.$off('firstPlayVideo');
      this.$root.eventHub.$off('destroyVideo');
      this.$root.eventHub.$off('videoMuted');
    },
    videoLoadeddata() {
      let temServerTime = common.getTemServerTime();
      let currentTime =
        this.live_video_mp4_appoint_time == 0
          ? this.currentTime
          : temServerTime - this.live_video_mp4_appoint_time;
      this.$refs.video.currentTime = currentTime;
      this.$refs.video.play();
      this.$emit('tip', false);
      if (this.$refs.video.paused) {
        this.$emit('firstPlay');
        //
      }
      this.$root.eventHub.$emit('createLog', {
        id: 'LMTrackEventTYKSeekTime',
        data: {
          client_time: temServerTime, // 客户端当前时间(秒),
          appoint_time: this.live_video_mp4_appoint_time, // 体验课开课时间(秒)
          seek_time: currentTime, //seek 到的时间点(秒)
        },
      });
    },
    videoPlaying() {
      //
      this.$emit('tip', false);
      clearTimeout(this.videoLoadTimeoutInterval);
    },
    videoWaiting() {
      //
      this.$root.eventHub.$emit('createLog', {
        id: 'LMTrackEventStreamCaton',
        data: {
          url: this.liveVideoUrlData.live_video_url,
          cdnIP: '',
        },
      });
      this.$emit('tip', true);
      this.playVideo();
    },
    videoError() {
      console.log(244,'loaderr');
      this.$emit('loaderr');
      clearTimeout(this.videoLoadTimeoutInterval);
      this.$root.eventHub.$emit('createLog', {
        id: 'LMTrackEventStreamLose',
        data: {
          url: this.liveVideoUrlData.live_video_url,
          cdnIP: '',
        },
      });
      //console.log('error')
    },
    playend() {
      // this.destroyVideo();
      // this.removeEventListener();
      this.$refs.video && this.$refs.video.pause();
      this.videoEnd = true;
      if (this.class_type === 10) {
        this.upDateLessonState(3);
        this.$root.eventHub.$emit('classOver');
      }
    },
    videoTimeupdate() {
      let element = this.$refs.video;
      if (this.class_type === 10) {
        let nowTime = Math.round(new Date() / 1000);
        if (nowTime - this.nowTimeRecord > 3 && this.nowTimeRecord > 0) {
          let temServerTime = common.getTemServerTime();
          let currentTime = temServerTime - this.live_video_mp4_appoint_time;
          if (currentTime >= this.durationTime && this.durationTime != '') {
            this.destroyVideo();
            this.removeEventListener();
            this.videoEnd = true;
            return;
          }

          this.$refs.video.currentTime = currentTime;
          this.$refs.video.play();
        }
        this.nowTimeRecord = Math.round(new Date() / 1000);
      }

      let time = Math.floor(element.currentTime);
      if (time === this.currentTime || element.paused || this.isDrag) return;
      this.currentTime = time;
      this.videoEnd = false;
      // console.log('---',time)
      let selfTime = this.sendLogArr.filter((v) => {
        return this.currentTime == v;
      })[0];
      if (!selfTime) return;
      this.showContent(selfTime);
    },
    showContent(key) {
      const obj = this.sendLogData[key];
      if (obj.type === 'send_quick_question') {
        let datas = {
          unique_id: ' ',
          data: {
            correct_answer: obj.correct_answer,
            quick_question_id: obj.value,
            type: obj.q_type,
          },
        };
        // 录播课需要把uniqueId传给后端
        if (this.class_type === 10) {
          datas.unique_id = obj.uniqueId;
        }
        this.$root.eventHub.$emit('question', datas, '');
        const sendDatas = {
          type: 'teacher_send_quick_question',
          unique_id: obj.uniqueId,
          data: {
            lesson_id: this.lesson_id,
            srv_time: common.getTemServerTime(),
            ots_time: common.getTemServerTime(),
            type: obj.q_type,
            teacher_id: this.teacher_id,
            quick_question_id: obj.value,
          },
        };
        this.$root.eventHub.$emit('apiMessage', JSON.stringify(sendDatas));
      } else if (obj.type === 'add_coin') {
        let datas = {
          unique_id: ' ',
          data: {
            coin: obj.value,
          },
        };
        this.$root.eventHub.$emit('coin', datas);
      } else if (obj.type === 'comments') {
        let datas = {
          unique_id: ' ',
          data: {
            task_data: {
              show: obj.value,
            },
          },
        };
        this.$root.eventHub.$emit('comments', datas);
      }
    },
    videoLoadedmetadata() {
      let temServerTime = common.getTemServerTime();
      this.durationTime = Math.floor(this.$refs.video.duration);
      let currentTime =
        this.live_video_mp4_appoint_time == 0
          ? 0
          : temServerTime - this.live_video_mp4_appoint_time;
      if (currentTime >= this.durationTime) {
        this.removeEventListener();
        this.destroyVideo();
        this.videoEnd = true;
      }
    },
    removeEventListener() {
      let element = this.$refs.video;
      element.removeEventListener('loadeddata', this.videoLoadeddata);
      element.removeEventListener('playing', this.videoPlaying);
      element.removeEventListener('waiting', this.videoWaiting);
      element.removeEventListener('timeupdate', this.videoTimeupdate);
      element.removeEventListener('error', this.videoError);
      element.removeEventListener('loadedmetadata', this.videoLoadedmetadata);
    },
    addEventListener() {
      let element = this.$refs.video;

      element.addEventListener('loadeddata', this.videoLoadeddata);
      element.addEventListener('playing', this.videoPlaying);
      element.addEventListener('waiting', this.videoWaiting);
      element.addEventListener('timeupdate', this.videoTimeupdate);
      element.addEventListener('error', this.videoError);
      element.addEventListener('loadedmetadata', this.videoLoadedmetadata);
    },
    creatPlayer() {
      // console.log('creatPlayer')

      this.destroyVideo();
      setTimeout(() => {
        // 录播课
        this.videoUrl =
          this.class_type === 10
            ? this.playbackUrl
            : this.liveVideoUrlData.live_video_url;
        common.set('live_video_url_now', this.videoUrl);

        // if (!this.videoUrl) {
        //   this.$emit('loaderr');
        //   return;
        // }
        if (Hls.isSupported() && this.videoUrl.includes('.m3u8')) {
          this.video = this.$refs.video;
          if (!this.video) return;
          this.hlsObj = new Hls();
          this.hlsObj.attachMedia(this.video);
          if (this.hlsObj) {
            this.hlsObj.loadSource(this.videoUrl);
            this.hlsObj.on(Hls.Events.MANIFEST_PARSED, () => {
              this.video.play();
              // this.removeEventListener();
              this.addEventListener();
              this.videoLoadTimeout();
            });
          }
        } else {
          this.$refs.video.src = this.videoUrl;
          this.removeEventListener();
          this.addEventListener();
          this.videoLoadTimeout();
        }
      }, 0);
    },
    videoLoadTimeout() {
      clearTimeout(this.videoLoadTimeoutInterval);
      console.log(418, '--------');
      this.videoLoadTimeoutInterval = setTimeout(() => {
        this.destroyVideo();
        this.$emit('loaderr');
      }, this.video_stream_load_timeout * 1000);
    },
    reconnection() {
      this.creatPlayer();
      this.$root.eventHub.$emit('createLog', {
        id: 'LMTrackEventPlayerRestart',
      });
    },
    destroyVideo() {
      this.videoUrl = '';
      clearTimeout(this.videoLoadTimeoutInterval);
      //
    },
  },
  beforeDestroy() {
    this.removeEventListener();
    this.destroyVideo();
    this.offEventHub();
  },
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
.playvideo {
  width: 100%;
  height: 100%;
  vertical-align: bottom;
  position: relative;

  video {
    width: 100%;
    height: 100%;
  }

  img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
}

.bottom {
  width: 100%;
  height: 86px;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 25;
}

.bottom_sub {
  width: 100%;
  height: 86px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.03));

  .bottom_cont {
    width: 100%;
    display: flex;
    height: 40px;
    padding-top: 20px;
    align-items: center;
  }

  .input_box {
    flex: 1;
    margin: 0 40px 0 15px;
  }

  .range {
    width: calc(100% + 22px);
    outline: none;
    -webkit-appearance: none; /*清除系统默认样式*/
    background: -webkit-linear-gradient(#008acf, #008acf) no-repeat, #333;
    background: -o-linear-gradient(#008acf, #008acf) no-repeat, #333;
    background: -moz-linear-gradient(#008acf, #008acf) no-repeat, #333;
    background: linear-gradient(#008acf, #008acf) no-repeat, #333;
    height: 3px; /*横条的高度*/
    pointer-events: none;
  }

  /*拖动块的样式*/

  .range::-webkit-slider-thumb {
    position: relative;
    z-index: 2;
    -webkit-appearance: none; /*清除系统默认样式*/
    height: 22px; /*拖动块高度*/
    width: 22px; /*拖动块宽度*/
    background: #008acf; /*拖动块背景*/
    border-radius: 50%; /*外观设置为圆形*/
    border: 8px solid #ffffff; /*设置边框*/
    box-shadow: 0 0 0 6px hsla(0, 0%, 100%, 0.5);
    pointer-events: auto;
  }

  .video-duration {
    padding-right: 10px;
    color: #ffffff;
    text-align: left;
  }

  .video-currentTime {
    width: 80px;
    color: #ffffff;
    text-align: right;
  }
}

.fade-enter-active {
  animation: fade 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.fade-leave-active {
  animation: fade 0.3s reverse cubic-bezier(0.645, 0.045, 0.355, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/video/videoplayer.vue